import type { ResourceRate } from '../../../services/vendorService';

/**
 * Client-side mirror of `resolveRate` (HE-M12): PENDING/REJECTED never price a line.
 * SUPERSEDED stays eligible so a lookup for a date in the old window still hits.
 */
export function liveApprovedRate(
  rates: ResourceRate[] | undefined,
  serviceAreaId: number | null | undefined,
  onDate: Date = new Date(),
): number | null {
  if (!rates?.length) return null;

  const live = rates.filter((rate) => {
    if (rate.status !== 'APPROVED' && rate.status !== 'SUPERSEDED') return false;
    if (serviceAreaId != null && rate.serviceAreaId !== serviceAreaId) return false;
    const from = new Date(rate.effectiveFrom);
    if (Number.isNaN(from.getTime()) || from > onDate) return false;
    if (rate.effectiveTo) {
      const to = new Date(rate.effectiveTo);
      if (!Number.isNaN(to.getTime()) && to < onDate) return false;
    }
    return true;
  });

  live.sort((a, b) => {
    const byDate = new Date(b.effectiveFrom).getTime() - new Date(a.effectiveFrom).getTime();
    return byDate !== 0 ? byDate : b.id - a.id;
  });

  return live[0]?.rate ?? null;
}
